import React from "react";

export function useDebouncedValue<T>(value: T, delayMs: number) {
	const [debounced, setDebounced] = React.useState(value);

	React.useEffect(() => {
		const t = setTimeout(() => setDebounced(value), delayMs);
		return () => clearTimeout(t);
	}, [value, delayMs]);
	return debounced;
}
